import React, { Component } from 'react';
import { HeaderSub } from '../Common/HeaderSub'

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from 'swiper';
import "swiper/css";
import 'swiper/css/thumbs';

import "../../css/aistudio.css";

/* 개발담당:양유빈
 * 화면기능:AI생성 화면
 * 세부설명:
*/

export class Creator extends Component {
    static displayName = Creator.name;

    constructor(props) {
        super(props);
        this.state = {
            ExtendShow: false,
            isAnimating: false,
            UpLoadImage: "",
            TemplateImage:""
        };

        this.menu_Click = this.menu_Click.bind(this);
        this.asideRef = React.createRef();
        this.handleFileSearchClick = this.handleFileSearchClick.bind(this);
        this.hiddenFileInput = React.createRef();
        this.handleChange = this.handleChange.bind(this);
    }

    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    }
    menu_Click() {
        if (this.state.isAnimating) return; // 애니메이션 중이면 클릭 방지

        this.setState({ isAnimating: true });
        if (this.state.ExtendShow) {
            const aside = this.asideRef.current;
            aside.classList.remove('show');
            setTimeout(() => {
                this.setState({
                    ExtendShow: false,
                    isAnimating: false
                });
            }, 300);
        } else {
            this.setState({ ExtendShow: true });
            setTimeout(() => {
                const aside = this.asideRef.current;
                if (aside) {
                    aside.classList.add('show');
                }
                setTimeout(() => {
                    this.setState({ isAnimating: false });
                }, 300);
            }, 10);
        }
    }
    handleFileSearchClick() {
        this.hiddenFileInput.current.click();
    }
    handleChange(event) {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ UpLoadImage: e.target.result }); 
            };
            reader.readAsDataURL(file);  
        } else {
            alert('이미지 파일을 선택해주세요.');
        }
        event.preventDefault();
    }

    handleCheckboxChange() {

    }
    handleImageDelete(imageIndex) {
        console.log('이미지 삭제:', imageIndex);
    }
    handleImageDownload() {
        console.log('이미지 다운로드');
    }
    handleImageFullscreen() {
        console.log('이미지 전체화면');
    }
     
    uiRender = {
        Swiper: () => {
            return            (
                <div className="swiper swiper-margin">
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 10,
                            depth: 150,
                            modifier: 1,
                            slideShadows: false,
                        }}
                        pagination={false}
                        modules={[EffectCoverflow, Pagination]}
                        className="swiper-slide"
                    >
                        <>
                            <SwiperSlide className="swiper-slide-ai">
                                <img src="https://swiperjs.com/demos/images/nature-1.jpg" alt="" onClick={() => { this.setState({ TemplateImage: "https://swiperjs.com/demos/images/nature-1.jpg" }) } } />
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide-ai">
                                <img src="https://swiperjs.com/demos/images/nature-2.jpg" alt="" onClick={() => { this.setState({ TemplateImage: "https://swiperjs.com/demos/images/nature-2.jpg" }) }} />
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide-ai">
                                <img src="https://swiperjs.com/demos/images/nature-3.jpg" alt="" onClick={() => { this.setState({ TemplateImage: "https://swiperjs.com/demos/images/nature-3.jpg" }) }} />
                            </SwiperSlide>
                        </>
                    </Swiper>
                </div>
            )
        },
        TemplateImage: () => {
            if (this.state.TemplateImage !== "") {
                return (
                    <div className="image-item">
                        <img src={this.state.TemplateImage} alt="" />
                        <div
                            className="image-action-btn image-delete-btn"
                            onClick={() => { this.setState({ TemplateImage: "" }) }}
                        />
                    </div>
                )
            }
            else {
                return (
                    <div className="image-item-setting image-item-template">
                        <div>이미지를 선택하여주세요.</div>
                    </div>
                )
            }  
        },
        UpLoadImage: () => {
           
            if (this.state.UpLoadImage != "") {
                return (
                    <div className="image-item">
                        <img src={this.state.UpLoadImage} alt=""  />
                        <div
                            className="image-action-btn image-delete-btn"
                            onClick={() => { this.setState({ UpLoadImage: "" }) }}
                        /> 
                    </div>
                )
            }
            else {
                return (
                    <div className="image-item-setting image-item-upload" onClick={this.handleFileSearchClick}>
                        <input type="file" className="item_hide"
                            ref={this.hiddenFileInput}
                            onChange={this.handleChange}
                        />
                        <div>이미지를 올려주세요.</div>
                    </div>
                )
            }
        },
        ResultImage: () => {
            return (
                <div className="result-content image-item">
                    <img src="https://swiperjs.com/demos/images/nature-2.jpg" alt="" />
                    <div className="image-action-btn image-fullscreen-btn" onClick={() => this.handleImageFullscreen()}></div>
                    <div className="image-action-btn image-download-btn" onClick={() => this.handleImageDownload()}></div>
                </div>
            )
        }
    }
    render() {
        return (
            <div>
                <HeaderSub
                    HeaderTitle="AI Studio"
                    LinkUrl="/"

                />
                <div className="expand_menu" onClick={() => { this.menu_Click() }}>
                </div>
                <div className={this.state.ExtendShow === true ? "item_hide" : ""}>
                    <main>
                        {this.uiRender.Swiper()}
                        <div className="image-container">
                            {this.uiRender.TemplateImage()}
                            {this.uiRender.UpLoadImage()}
                        </div>
                        <button className="run-btn">Run</button>
                    </main>
                    <section>
                        {this.uiRender.ResultImage()}
                    </section>
                </div>
                <aside
                    ref={this.asideRef}
                    className={this.state.ExtendShow === false ? "expand_panel item_hide" : "expand_panel"}
                >
                    <div className="checkbox-container">
                        <div className="checkbox-row">
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                Folding
                            </label>
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                Slide
                            </label>
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                Gallay
                            </label>
                        </div>
                        <div className="checkbox-row">
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                상의
                            </label>
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                하의
                            </label>
                            <label className="checkbox-item">
                                <input type="checkbox" />
                                드레스
                            </label>
                        </div>
                    </div>
                </aside>
            </div>
        );
    }
}